import * as React from 'react';
import { IVehicleTile } from '../../../../../types/vehicleTile';
import ReturnVisitorCarousel from '../../../../../components/carousels/home-base-hero-carousel/ReturnVisitorCarousel';
import { RecommendationsPlaceholderCarousel } from '../../../../../components/carousels/home-base-hero-carousel/RecommendationsPlaceholderCarousel';
import { ANALYTICS_CONSTANTS, trackEDDL } from '../../../../../utilities/analytics';
import { useEffect } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import useAppState from '../../../../../common/state/appState';

interface IRecommendedCarouselProps {
    hasLoadedRecommendedTab: boolean;
    recommendedVehicleList: IVehicleTile[];
    isVisible: boolean;
    favoritedStockNumberList: number[];
    isLoadingRecommendedTab: boolean;
    onOpenSnackBar: (text: string) => any;
}

const RecommendedCarousel = ({
    hasLoadedRecommendedTab,
    recommendedVehicleList,
    isVisible,
    favoritedStockNumberList,
    isLoadingRecommendedTab,
    onOpenSnackBar,
}: IRecommendedCarouselProps) => {
    const getFbsDataForStockNumbers = useAppState((state) => state.getFbsDataForStockNumbers);
    const fbsData = useAppState((state) => state.fbsData);
    useEffect(() => {
        if (!recommendedVehicleList.length) return;
        getFbsDataForStockNumbers(recommendedVehicleList.map((v) => v.stockNumber));

        const allStockNumbers = recommendedVehicleList.map((vehicle: IVehicleTile) => vehicle.stockNumber).join('|');

        trackEDDL({
            event: ANALYTICS_CONSTANTS.EVENTS.IMPRESSION.RECOMMENDED_CAR,
            recommendations: {
                stockNumber: '',
                similarVehicles: allStockNumbers,
                carouselLength: String(recommendedVehicleList.length),
            },
            module: {
                moduleExperience: 'VR|Homepage|You might like',
            },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [recommendedVehicleList]);

    return hasLoadedRecommendedTab && recommendedVehicleList.length > 0 ? (
        <ReturnVisitorCarousel
            id="kmx-recommended-carousel"
            carouselName="recommended"
            analyticsName="Recommended"
            isVisible={isVisible}
            vehicleTileList={recommendedVehicleList}
            favoritedStockNumberList={favoritedStockNumberList}
            ariaLabel="Recommended Vehicles"
            enableRemove={false}
            fbsData={fbsData}
            onOpenSnackBar={onOpenSnackBar}
            sectionName="You might like"
        />
    ) : isLoadingRecommendedTab ? (
        <Box sx={{ minHeight: { xs: 394, sm: 480, md: 464 } }}>
            <Stack alignItems="center" justifyContent="center" sx={{ minHeight: 320 }}>
                <CircularProgress color="secondary" size={64} />
            </Stack>
        </Box>
    ) : hasLoadedRecommendedTab && recommendedVehicleList.length === 0 ? (
        <RecommendationsPlaceholderCarousel />
    ) : null;
};

export default RecommendedCarousel;
